import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=2b528e0c&scoped=true&"
import script from "./Placeholder.vue?vue&type=script&lang=ts&"
export * from "./Placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=2b528e0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b528e0c",
  null
  
)

export default component.exports